import { Brand } from '@/brandConfig/typings';
import { getUrlParams } from '@/utils/urlParse';
import { BRAND_NAME } from './constant';
let brand = localStorage.getItem(BRAND_NAME) || Brand.Xwx;
if (import.meta.env.VITE_APP_ENV === 'dev') {
  // 本地环境逻辑，因为esm引入组件的时候会执行一次，所以这里需要判断是否是本地环境
  const { brand: urlBrand } = getUrlParams();
  brand = urlBrand || brand;
} else {
  // 兼容测试环境和线上环境
  if (window.location.origin.includes('wen-su')) {
    brand = Brand.Xwyk;
  }
}
export const isXwx = +brand === +Brand.Xwx;
export const isXwsy = +brand === +Brand.Xwsy;
export const isXwyk = +brand === +Brand.Xwyk;

export { brand };
